<script setup lang="ts">
interface Props {
  status: 'awaitingNetwork' | 'enqueued' | 'uploading' | 'failed' | 'uploaded'
  progress: number;
}

const props = defineProps<Props>();
const platformStore = usePlatformStore();

const { t } = useEkI18n();

const icon = computed(() => {
  switch (props.status) {
    case 'awaitingNetwork': return ioniconsWifi;
    case 'enqueued': return ioniconsArrowUpCircle;
    case 'uploading': return ioniconsCloudUpload;
    case 'failed': return ioniconsWarning;
    case 'uploaded': return ioniconsCheckmarkCircle;
    default: return ioniconsAlertCircleOutline;
  }
});

const color = computed<string>(() => {
  switch (props.status) {
    case 'awaitingNetwork': return 'warning';
    case 'enqueued': return 'warning';
    case 'uploading': return 'primary';
    case 'failed': return 'danger';
    case 'uploaded': return 'success';
    default: return 'medium';
  }
});

const statusText = computed(() => {
  switch (props.status) {
    case 'awaitingNetwork': return t('documents.status.awaitingNetwork');
    case 'enqueued': return t('documents.status.enqueued');
    case 'uploading': return t('documents.status.uploading');
    case 'failed': return t('documents.status.failed');
    case 'uploaded': return t('documents.status.uploaded');
    default: return '';
  }
});

</script>

<template>
  <div class="flex ion-align-items-center">
    <IonSpinner
      v-if="platformStore.isWeb && status === 'uploading'"
      class="mr-1"
      :color="color"
    />
    <IonIcon
      v-else
      class="mr-1"
      :color="color"
      :icon="icon"
    />
    <IonText
      :color="color"
      class="subtitle"
    >
      {{ statusText }}
    </IonText>
  </div>
  <IonProgressBar
    v-if="platformStore.isMobile && status === 'uploading'"
    :value="progress"
  />
</template>

<style scoped>
.subtitle {
    font-size: smaller;
}

ion-spinner {
  height: 16px;
  width: 16px;
}
</style>
